var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUdyamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(-20 -65)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(20 65)",
    fill: "#ff4100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_7_",
    "data-name": "download (7)",
    transform: "translate(-158.72 -70.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M389.955,473.68a2.488,2.488,0,0,0-1.171,4.682V481.2l1.006-.719,1.294.719v-2.834a2.492,2.492,0,0,0,1.314-2.2,2.42,2.42,0,0,0-2.444-2.485Z",
    transform: "translate(-188.613 -312.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M207.216,142.91h-17.99c5.031,8.133-5.031,16.265,0,24.4h9.9v-.78a3.553,3.553,0,1,1,4.477,0v.8h3.635c-5.052-8.153,5.011-16.286-.021-24.418Zm-14.293,3.327h12.363a.534.534,0,1,1,0,1.068H192.922a.544.544,0,0,1-.534-.534A.53.53,0,0,1,192.922,146.237ZM196.742,164H190.56a.534.534,0,0,1,0-1.068h6.182a.544.544,0,0,1,.534.534A.531.531,0,0,1,196.742,164Zm7.024-4.189H191.4a.534.534,0,1,1,0-1.068h12.363a.534.534,0,0,1,0,1.068Zm1.006-4.169H192.43a.534.534,0,1,1,0-1.068h12.363a.534.534,0,1,1-.02,1.068Zm.513-4.169H192.922a.534.534,0,1,1,0-1.068h12.363a.534.534,0,1,1,0,1.068Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdyamIcon);
export default __webpack_public_path__ + "static/media/udyam-icon.7c6915c8107c5b3be01bd88548b4e97b.svg";
export { ForwardRef as ReactComponent };